import type { ComponentType } from 'react';

import { MemoryRouter } from '@makemydeal/dr-react-18-wrappers';
import { TradeInOverview } from '@makemydeal/dr-sales-checkin-components';
import { FEATURES, routingConfig, type ShowroomSectionKey } from '@makemydeal/dr-sales-checkin-types';

import DealSummary from '../Showroom/content/DealSummary';
import VehicleDetails from '../Showroom/content/VehicleDetails';
import { CustomerDetailsSection } from './CustomerDetailsSection';

/**
 * Deal Summary as a section of the page. The section owns the router the activity routes on, seeded
 * at the activity's own base route, so its step navigations (Request Quote -> Quote Requested ->
 * View Quote -> Accepted Deal) move that in-memory history and never the browser's — the page keeps
 * one address (FR-023). The other three sections need no wrapper: only Deal Summary routes
 * internally.
 */
const DealSummarySection = () => (
    <MemoryRouter initialEntries={[routingConfig.DEAL_SUMMARY]}>
        <DealSummary />
    </MemoryRouter>
);

export const SECTION_COMPONENTS: Record<ShowroomSectionKey, ComponentType> = {
    [FEATURES.VEHICLE_DETAILS]: VehicleDetails,
    [FEATURES.TRADE_IN]: TradeInOverview,
    [FEATURES.CUSTOMER_DETAILS]: CustomerDetailsSection,
    [FEATURES.DEAL_SUMMARY]: DealSummarySection
};
